import { Info } from "./GridFrameworks";

export const columnDef = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: Info,
        width: 60,
    },
    {
        headerName: "Name",
        field: "Name",
        flex: 1,
    },
    {
        headerName: "Short Name",
        field: "ShortName",
        flex: 1,
    },
    {
        headerName: "Headquarters",
        field: "Headquarters",
        flex: 1,
    },
    {
        headerName: "Website",
        field: "Website",
        flex: 1,
    },
    {
        headerName: "Status",
        field: "Status",
        cellRenderer: "StatusCellRenderer",
        width: 120,
    },
];
